import { render, staticRenderFns } from "./input3Freq.vue?vue&type=template&id=1ec2f297"
import script from "./input3Freq.vue?vue&type=script&lang=js"
export * from "./input3Freq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports